export class ExecutionReportProjectDto {
  id: string;
  projectId: string;
  code?: string;
  status?: string;
}
